import React from 'react';
import { X, Activity } from 'lucide-react';
import { MONO } from './ui';

// 1950s RP vs today's SSBE for one tapped word.
export const PronCard = ({ word, pron, note, labels, labDialect, t, onClose }) => {
  if (!word || !pron) return null;
  const [old, now] = pron;
  return (
    <div className="mt-3 rounded-xl bg-white text-slate-900 p-4 shadow-2xl" data-testid="pron-card">
      <div className="flex items-start justify-between gap-3">
        <p className="text-xl font-extrabold">{word}</p>
        <button onClick={onClose} className="p-1 rounded-full hover:bg-slate-100" aria-label="close" data-testid="pron-card-close"><X className="w-4 h-4" /></button>
      </div>
      <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div className="rounded-lg bg-amber-50 border border-amber-200 p-3">
          <p className="text-[10px] uppercase tracking-widest text-amber-700 font-bold" style={MONO}>{labels?.[0] || t.pronOld}</p>
          <p className="mt-1 text-xl sm:text-2xl font-bold" style={MONO} data-testid="pron-old">[{old}]</p>
        </div>
        <div className="rounded-lg bg-blue-50 border border-blue-200 p-3">
          <p className="text-[10px] uppercase tracking-widest text-blue-700 font-bold" style={MONO}>{labels?.[1] || t.pronNew}</p>
          <p className="mt-1 text-xl sm:text-2xl font-bold" style={MONO} data-testid="pron-new">[{now}]</p>
        </div>
      </div>
      {note && <p className="mt-3 text-xs text-slate-600 leading-relaxed">{note}</p>}
      {labDialect && (
        <button onClick={() => window.dispatchEvent(new CustomEvent('vf-open-tool', { detail: { id: 'vocal-lab', url: `/lms/vocal-lab?d=${labDialect}&text=${encodeURIComponent(word)}&cmp=${encodeURIComponent(`${old}|${now}`)}&cmpl=${encodeURIComponent((labels || [t.pronOld, t.pronNew]).join('|'))}` } }))}
          className="mt-3 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#060d24] hover:bg-blue-700 text-white text-xs font-bold transition-colors" data-testid="pron-open-lab">
          <Activity className="w-4 h-4 text-cyan-300" />{t.openInLab}
        </button>
      )}
    </div>
  );
};
